export interface RecipeItem {
  id: string
  title: string
  imageUrl: string
  category: string
  videoUrl?: string
  posterUrl?: string
}

export interface ExploreItem {
  id: string
  title: string
  imageUrl: string
  videoUrl?: string
  type: 'image' | 'video'
  aspectRatio: '16:9' | '9:16'
}

// Recipe mock data - horizontal scrolling cards
export const recipeData: RecipeItem[] = [
  {
    id: 'recipe-1',
    title: 'Realistic Film',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtjdGgyMmd2ZXNuZnA4ZzA2emVjY3Y5ay5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kcth239ybbfjyvtm8bvpzb2z.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtjdGgyMmd2ZXNuZnA4ZzA2emVjY3Y5ay5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-2',
    title: 'Anime OP',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtjdGdxNTN0am5teTlxZDk1bWRrOHloMS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kctgq6nh9zk4bh2j6s795ktw.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtjdGdxNTN0am5teTlxZDk1bWRrOHloMS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-3',
    title: 'Explainer Video',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieWF4NzhiMDF4OWRxZW15aDQwcmRqMS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbz197fgardag19b8wsz30cv.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieWF4NzhiMDF4OWRxZW15aDQwcmRqMS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-4',
    title: 'Anime Short Film',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieXBkMTZ5Y3c3eDkxdmpoc3J0N3Qwei5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbypg93v3fqws0m7cz6ed7y2.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieXBkMTZ5Y3c3eDkxdmpoc3J0N3Qwei5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-5',
    title: 'Anime MV',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieW42anR6OHJxN3Q5MTRqY2Nla3Fzci5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbyn2nbhr9rf90g2bya3gntc.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieW42anR6OHJxN3Q5MTRqY2Nla3Fzci5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-6',
    title: 'Use Stock Videos',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtiejNucjVuN3g0d3I0ajBwNjVubnEwYi5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbz3ntts5z10dcw8pxba8ced.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtiejNucjVuN3g0d3I0ajBwNjVubnEwYi5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-7',
    title: 'Make a Song',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieW15Nmp0dzJnZ2pyeTByOXQyZ3Q3dC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbymybr4r5c1fk4kkm64fzmw.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieW15Nmp0dzJnZ2pyeTByOXQyZ3Q3dC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-8',
    title: 'Sketch Explainer',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieXp6eWZhbTB3NGZwN3c5cnFteTEyMy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbyzzzfa98zpyb92sw4vzs8y.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtieXp6eWZhbTB3NGZwN3c5cnFteTEyMy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  },
  {
    id: 'recipe-9',
    title: 'PPT Video',
    imageUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtiejB2dG5lc2twNmN4NGs3d2pxOHBndi5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0=',
    category: 'Video',
    videoUrl: 'https://oss.prd.medeo.app/recipes/video/recipe_video_01kbz0vwkvzjfdn1dekenhtn39.mp4',
    posterUrl: 'https://static-us.medeo.one2x.ai/eyJidWNrZXQiOiJwcmQtbWVkZW8tdjIiLCJrZXkiOiJyZWNpcGVzL2ltYWdlL3JlY2lwZV90aHVtYl8wMWtiejB2dG5lc2twNmN4NGs3d2pxOHBndi5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjUxMiwiZml0IjoiY29udGFpbiJ9fX0='
  }
]

// Helper function to generate Explore items with different aspect ratios
const generateExploreItems = (startId: number, count: number): ExploreItem[] => {
  const items: ExploreItem[] = []
  const aspectRatios: Array<'16:9' | '9:16'> = ['16:9', '9:16']

  const imageUrls16x9 = [
    'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=600&h=338&fit=crop',
    'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=600&h=338&fit=crop',
    'https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=600&h=338&fit=crop',
    'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=600&h=338&fit=crop',
    'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=600&h=338&fit=crop',
    'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=600&h=338&fit=crop',
  ]

  const imageUrls9x16 = [
    'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=338&h=600&fit=crop',
    'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=338&h=600&fit=crop',
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=338&h=600&fit=crop',
    'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=338&h=600&fit=crop',
    'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=338&h=600&fit=crop',
    'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=338&h=600&fit=crop',
  ]

  const videoUrls = [
    'https://assets.mixkit.co/videos/preview/mixkit-waves-in-the-water-1164-large.mp4',
    'https://assets.mixkit.co/videos/preview/mixkit-tree-branches-in-the-breeze-1188-large.mp4',
    'https://assets.mixkit.co/videos/preview/mixkit-forest-stream-in-the-sunlight-529-large.mp4',
  ]

  for (let i = 0; i < count; i++) {
    const aspectRatio = aspectRatios[Math.floor(Math.random() * aspectRatios.length)] || '16:9'
    const imageArray = aspectRatio === '16:9' ? imageUrls16x9 : imageUrls9x16
    const imageUrl = imageArray[i % imageArray.length] || imageUrls16x9[0] || ''
    const videoUrl = videoUrls[i % videoUrls.length]

    items.push({
      id: `explore-${startId + i}`,
      title: `Creative Work ${startId + i}`,
      imageUrl,
      videoUrl,
      type: 'video',
      aspectRatio,
    })
  }

  return items
}

// Generate 12 pages of Explore data (each page has ~12 items) - 144 total items
export const explorePage1: ExploreItem[] = generateExploreItems(1, 12)
export const explorePage2: ExploreItem[] = generateExploreItems(13, 12)
export const explorePage3: ExploreItem[] = generateExploreItems(25, 12)
export const explorePage4: ExploreItem[] = generateExploreItems(37, 12)
export const explorePage5: ExploreItem[] = generateExploreItems(49, 12)
export const explorePage6: ExploreItem[] = generateExploreItems(61, 12)
export const explorePage7: ExploreItem[] = generateExploreItems(73, 12)
export const explorePage8: ExploreItem[] = generateExploreItems(85, 12)
export const explorePage9: ExploreItem[] = generateExploreItems(97, 12)
export const explorePage10: ExploreItem[] = generateExploreItems(109, 12)
export const explorePage11: ExploreItem[] = generateExploreItems(121, 12)
export const explorePage12: ExploreItem[] = generateExploreItems(133, 12)

// All pages combined
export const allExplorePages = [
  explorePage1,
  explorePage2,
  explorePage3,
  explorePage4,
  explorePage5,
  explorePage6,
  explorePage7,
  explorePage8,
  explorePage9,
  explorePage10,
  explorePage11,
  explorePage12,
]
